import type { Components, Theme } from "@mui/material";

export const MuiButton = {
  styleOverrides: {
    root: { textTransform: "none", borderRadius: "8px" },
  },
  defaultProps: { size: "small" },
} satisfies Components<Theme>["MuiButton"];

export const MuiToggleButton = {
  styleOverrides: {
    root: { textTransform: "none" },
  },
  defaultProps: { size: "small" },
} satisfies Components<Theme>["MuiToggleButton"];

export const MuiToggleButtonGroup = { defaultProps: { size: "small" as const } };
export const MuiIconButton = { defaultProps: { size: "small" as const } };
